{
  "replaceMessage": "Перетащите файл для замены"
}
